import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { productApi } from '../../shared/api/endpoints';
import './DealsHot.css';

export default function DealsHot() {
  const [deals, setDeals] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    productApi
      .list({ isDeal: true, limit: 8 })
      .then((res) => setDeals(res.data.data?.items || []))
      .catch(() => setDeals([]))
      .finally(() => setLoaded(true));
  }, []);

  if (!loaded || deals.length === 0) return null;

  const [feature, ...rest] = deals;
  const grid = rest.slice(0, 4);

  return (
    <section className="section deals section--lite">
      <div className="container">
        <div className="deals__head">
          <div>
            <p className="section-eyebrow">Limited heat</p>
            <h2 className="section-title">Deals Too Hot to Hold</h2>
            <p className="section-sub">
              Scorching prices, molten silhouettes — grab them before the glow cools.
            </p>
          </div>
          <Link to="/products?isDeal=true" className="btn btn-gold">
            View all heat →
          </Link>
        </div>

        <div className="deals__feature">
          <Link to={`/products/${feature._id}`} className="deals__feature-card">
            <div
              className="deals__feature-img"
              style={{ backgroundImage: `url(${feature.images?.[0]})` }}
            />
            <div className="deals__feature-copy">
              <span className="deals__badge">{feature.dealBadge || 'FEATURED DEAL'}</span>
              <h3>{feature.title}</h3>
              <p>{feature.subtitle || 'A limited drop from the atelier.'}</p>
              <div className="deals__price">
                <strong>₹{feature.sellingPrice?.toLocaleString?.() || feature.sellingPrice}</strong>
                {feature.actualPrice > feature.sellingPrice && (
                  <s>₹{feature.actualPrice.toLocaleString()}</s>
                )}
              </div>
            </div>
          </Link>

          <div className="deals__trust">
            <div>
              <strong>Free shipping</strong>
              <span>On orders above ₹2,999</span>
            </div>
            <div>
              <strong>30-day returns</strong>
              <span>Easy atelier exchanges</span>
            </div>
            <div>
              <strong>Secure checkout</strong>
              <span>Encrypted & protected</span>
            </div>
          </div>
        </div>

        <div className="deals__grid">
          {grid.map((deal, i) => (
            <motion.div
              key={deal._id}
              initial={{ opacity: 0, scale: 0.97 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06 }}
            >
              <Link to={`/products/${deal._id}`} className="deals__card">
                <div
                  className="deals__img"
                  style={{ backgroundImage: `url(${deal.images?.[0]})` }}
                >
                  <span className="deals__badge">{deal.dealBadge || 'HOT'}</span>
                </div>
                <div className="deals__meta">
                  <h3>{deal.title}</h3>
                  <p>{deal.subtitle}</p>
                  <div className="deals__price">
                    <strong>₹{deal.sellingPrice?.toLocaleString?.() || deal.sellingPrice}</strong>
                    {deal.actualPrice > deal.sellingPrice && (
                      <s>₹{deal.actualPrice.toLocaleString()}</s>
                    )}
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
